import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelAssets } from './fetchChannelAssets';

export function getChannelAssets() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchChannelAssets>>>(queryKeys.channelAssets);
}
